<template>
  <div class="home-wrapper">
    <Header />
    <section class="section tenders">
      <div class="content-wrapper">
        <div class="heading">
          <h1 class="title">Все тендеры Беларуси в одном сервисе</h1>
          <p class="text">
            Перестаньте искать – начните выигрывать тендеры с Bytorg!
          </p>
          <Button
            variant="gradient"
            class="tenders-button"
            @click.stop="openRegistrationModal"
          >
            Попробовать бесплатно
          </Button>
        </div>

        <div class="images">
          <picture>
            <source media="(max-width: 767px)" :srcset="mainMobile" />
            <source media="(max-width: 1439px)" :srcset="mainTablet" />
            <img
              :src="mainDesktop"
              fetchpriority="high"
              class="main-desktop"
              alt=""
            />
          </picture>
        </div>

        <div class="summary">
          <SummaryItem v-for="(item, index) in summaryItems" :key="index">
            <template #title>{{ item.title }}</template>
            <template #subtitle>{{ item.subtitle }}</template>
          </SummaryItem>
        </div>
        <SocialIcons />
      </div>
    </section>
    <section id="how-it-works" class="section how-it-works">
      <div class="content-wrapper">
        <h2 class="title">Как это работает</h2>
        <article class="first-slide">
          <div class="description">
            <h4 class="title">Настройте автоматический поиск под себя</h4>
            <p class="text">
              Создайте поисковый фильтр - укажите ключевые слова, выберите
              нужные параметры: тип тендера, заказчика, регион и прочее.
              Сохраните его. Создайте любое количество фильтров под ваши задачи.
              Теперь весь поиск автоматизирован.
            </p>
          </div>
          <img src="@/assets/img/home/how-it-works-1.webp" class="image" />
        </article>
        <article class="second-slide">
          <div class="description">
            <h4 class="title">Находите больше подходящих закупок</h4>
            <p class="text">
              После настройки сервиса получайте актуальные данные по релевантным
              тендерам и аукционам, которые обновляются автоматически каждые 15
              минут
            </p>
          </div>
          <img src="@/assets/img/home/how-it-works-2.webp" class="image" />
        </article>
      </div>
    </section>
    <section id="features" class="section features">
      <div class="content-wrapper">
        <Carousel>
          <div class="slide">
            <div class="description">
              <div class="title">Метки</div>
              <div class="text">
                Инструмент управления, который превращает хаотичный список
                тендеров в четкий и контролируемый процесс отслеживания статуса
                каждой сделки. Это позволяет вам и вашей команде четко видеть
                стадию проработки каждого тендера.
              </div>
            </div>
            <img
              src="@/assets/img/home/carousel-1-slide-1.webp"
              loading="lazy"
              class="image"
            />
          </div>
          <div class="slide">
            <div class="description">
              <div class="title">Микропоиск</div>
              <div class="text">
                Обеспечивает мгновенную и точную сортировку внутри уже
                сформированного фильтра. Больше не нужно повторно применять
                сложные настройки — получайте нужные данные за секунду.
              </div>
            </div>
            <img
              src="@/assets/img/home/carousel-1-slide-2.webp"
              loading="lazy"
              class="image"
            />
          </div>
          <div class="slide">
            <div class="description">
              <div class="title">Быстрый доступ к документации</div>
              <div class="text">
                Экономьте драгоценные минуты. По каждому тендеру вы найдете
                прямой доступ к полному пакету конкурсной документации. Все
                доступно в один клик, что позволяет мгновенно приступить к
                изучению требований и подготовке заявки.
              </div>
            </div>
            <img
              src="@/assets/img/home/carousel-1-slide-3.webp"
              loading="lazy"
              class="image"
            />
          </div>
          <div class="slide">
            <div class="description">
              <div class="title">Обновление каждые 15 минут</div>
              <div class="text">
                Мы гарантируем актуальность данных, обновляя информацию по всем
                площадкам каждые 15 минут. Это значит, что вы увидите новый
                тендер раньше конкурентов и получите больше времени на его
                проработку.
              </div>
            </div>
            <img
              src="@/assets/img/home/carousel-1-slide-4.webp"
              loading="lazy"
              class="image"
            />
          </div>
        </Carousel>
      </div>
    </section>
    <section class="section notifications">
      <div class="content-wrapper">
        <div class="container">
          <div class="content">
            <div class="description">
              <h2 class="title">
                Получайте мгновенный доступ и оповещения на e-mail по графику
              </h2>
              <p class="text">
                Настройте в сервисе почтовые уведомления о публикации свежих
                тендеров. Рассылка будет приходить автоматически в выбранное
                вами время.
              </p>
            </div>
            <Button
              variant="gradient"
              class="notifications-button"
              @click.stop="openRegistrationModal"
            >
              Попробовать бесплатно
            </Button>
            <img
              src="@/assets/img/home/phone1.webp"
              loading="lazy"
              class="phone1"
            />
            <img
              src="@/assets/img/home/phone2.webp"
              loading="lazy"
              class="phone2"
            />
          </div>
        </div>
      </div>
    </section>
    <section id="reviews" class="section reviews">
      <div class="content-wrapper">
        <h2 class="title">Нам доверяют лидеры рынка</h2>
        <Carousel>
          <ParthnerSlide
            v-for="(slide, index) in slides"
            :key="index"
            v-bind="slide"
          />
        </Carousel>
      </div>
    </section>
    <section id="callback" class="section callback">
      <div class="content-wrapper">
        <h2 class="title">
          Заинтересованы в сотрудничестве? Нужна консультация?
        </h2>
        <CallRequestForm />
      </div>
    </section>
    <section id="faq" class="section faq">
      <div class="content-wrapper">
        <h2 class="title">FAQ</h2>
        <Questions :questions="questions" />
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Button from "@/components/homePage/Button.vue";
import SummaryItem from "@/components/homePage/SummaryItem.vue";
import Carousel from "@/components/homePage/Carousel.vue";
import CallRequestForm from "@/components/homePage/CallRequestForm.vue";
import Questions from "@/components/homePage/Questions.vue";
import Header from "@/components/homePage/Header.vue";
import Footer from "@/components/homePage/Footer.vue";
import SocialIcons from "@/components/homePage/SocialIcons.vue";
import RegistrationModal from "@/components/homePage/RegistrationModal.vue";
import { RegistrationModalProperties } from "@/utils/modalsProperties";
import { questions } from "@/utils/constants/questions";
import { carouselSlides } from "@/utils/constants/carouselSlides";
import ParthnerSlide from "@/components/homePage/ParthnerSlide.vue";
import mainDesktop from "@/assets/img/home/main-desktop.webp";
import mainTablet from "@/assets/img/home/main-tablet.webp";
import mainMobile from "@/assets/img/home/main-mobile.webp";

export default {
  name: "NewHome",
  components: {
    Button,
    SummaryItem,
    Carousel,
    CallRequestForm,
    Questions,
    Header,
    Footer,
    SocialIcons,
    ParthnerSlide,
  },
  data() {
    return {
      summaryItems: [
        { title: "85%", subtitle: "экономия времени менеджера на поиске" },
        { title: "10", subtitle: "ключевых площадок Беларуси в одном месте" },
        {
          title: "400+",
          subtitle: "компаний уже упростили работу с тендерами",
        },
      ],
      questions,
      slides: carouselSlides,
      mainDesktop,
      mainTablet,
      mainMobile,
    };
  },
  methods: {
    openRegistrationModal() {
      this.$modal.show(RegistrationModal, null, RegistrationModalProperties);
    },
  },
  mounted() {
    if (this.$route.query.registration === "true") {
      this.openRegistrationModal();
    }
  },
};
</script>

<style scoped lang="less">
.content-wrapper {
  background-color: white;
}
.home-wrapper {
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 100vh;
  background-color: #ffffff;

  > section:not(:first-of-type) {
    margin-top: 160px;
    @media (max-width: 1439px) {
      margin-top: 100px;
    }
    @media (max-width: 767px) {
      margin-top: 80px;
    }
  }
  > section:last-of-type {
    margin-bottom: 160px;
    @media (max-width: 1439px) {
      margin-bottom: 100px;
    }
    @media (max-width: 767px) {
      margin-top: 80px;
    }
  }
  .section {
    background-color: #fff;
    @media (max-width: 1480px) {
      padding: 0 20px;
    }
    @media (max-width: 767px) {
      padding: 0 10px;
    }
    .title {
      background-color: white;
      width: 100%;
      font-family: Montserrat;
      font-weight: 600;
      font-style: SemiBold;
      font-size: 64px;
      line-height: 1;
      text-align: center;
      margin: 0;
      @media (max-width: 1439px) {
        font-size: 48px;
      }
      @media (max-width: 767px) {
        font-size: 32px;
      }
    }
  }
  .tenders {
    width: 100%;
    height: max-content;
    background-color: #484e55;
    padding-bottom: 40px;
    @media (max-width: 1439px) {
      padding-bottom: 35px;
    }
    @media (max-width: 767px) {
      padding-top: 88px;
    }
    .content-wrapper {
      background-color: #484e55;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: max-content max-content;
      grid-template-areas:
        "heading images"
        "summary summary";
      @media (max-width: 1439px) {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(4, fit-content);
        grid-template-areas: "heading" "images" "socials" "summary";
      }
      .heading {
        grid-area: heading;
        display: flex;
        flex-direction: column;
        color: #ffffff;
        .title {
          font-family: Montserrat;
          background-color: #484e55;
          font-weight: 700;
          font-style: Bold;
          font-size: 64px;
          line-height: 1;
          margin: 0;
          margin-bottom: 24px;
          margin-top: 100px;
          text-align: left;
          @media (max-width: 1439px) {
            font-family: Montserrat;
            font-weight: 700;
            font-size: 48px;
            margin-bottom: 12px;
            margin-top: 50px;
          }
          @media (max-width: 767px) {
            font-size: 32px;
            margin-top: 32px;
            width: 304px;
          }
        }
        .text {
          font-family: Montserrat;
          font-weight: 500;
          font-style: Medium;
          font-size: 24px;
          line-height: 1;
          margin-bottom: 52px;
          padding-right: 100px;
          @media (max-width: 1439px) {
            font-size: 20px;
            margin-bottom: 24px;
            max-width: 600px;
          }
          @media (max-width: 767px) {
            font-size: 18px;
            padding: 0;
            margin-bottom: 32px;
          }
        }
        .tenders-button {
          width: 384px;
          height: 79px;
          font-family: Montserrat;
          font-weight: 600;
          font-size: 24px;
          line-height: 100%;
          letter-spacing: 0%;
          @media (max-width: 767px) {
            width: 100%;
            height: 59px;
            font-size: 20px;
            margin-bottom: 32px;
          }
        }
      }
      .images {
        grid-area: images;
        position: relative;
        height: 665px;
        display: flex;
        align-items: center;
        justify-content: center;

        @media (max-width: 1439px) {
          height: 550px;
        }

        @media (max-width: 767px) {
          height: 273px;
        }

        .main-desktop {
          position: absolute;
          top: 0;
          right: 0;
          width: 100%;

          @media (max-width: 1439px) {
            width: 587px;
            top: 50%;
            left: 50%;
            right: auto;
            transform: translate(-50%, -50%);
          }
          @media (max-width: 767px) {
            width: 342px;
          }
        }
      }
      .summary {
        grid-area: summary;
        display: flex;
        justify-content: space-between;
        margin-top: 9px;
        padding-right: 70px;
        @media (max-width: 1439px) {
          padding-right: 0;
        }
        @media (max-width: 767px) {
          flex-direction: column;
          gap: 10px;
          margin-top: 32px;
        }
        > * {
          width: 283px;
          @media (max-width: 1439px) {
            width: 235px;
          }
        }
      }
    }
  }
  .how-it-works {
    .content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 132px;
      @media (max-width: 1439px) {
        gap: 80px;
      }
      @media (max-width: 767px) {
        gap: 52px;
      }
      .first-slide,
      .second-slide {
        width: 100%;
        height: fit-content;
        display: flex;
        gap: 36px;
        @media (max-width: 1439px) {
          flex-direction: column;
          align-items: end;
        }
        @media (max-width: 767px) {
          align-items: start;
        }
        .description {
          width: 100%;
          max-width: 590px;
          padding-right: 26px;
          display: flex;
          flex-direction: column;
          gap: 25px;
          background-color: #fff;
          @media (max-width: 1439px) {
            padding: 0;
            align-items: end;
          }
          @media (max-width: 767px) {
            align-items: start;
          }
          .title {
            text-align: left;
            font-family: Montserrat;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 36px;
            line-height: 1;

            @media (max-width: 1439px) {
              text-align: right;
              font-weight: 700;
              font-size: 32px;
              max-width: 400px;
            }
            @media (max-width: 767px) {
              text-align: left;
              font-weight: 600;
              font-size: 24px;
              max-width: 300px;
            }
          }
          .text {
            text-align: left;
            font-family: Montserrat;
            font-weight: 400;
            font-style: Regular;
            font-size: 24px;
            line-height: 1;
            background-color: #fff;
            @media (max-width: 1439px) {
              text-align: right;
              font-weight: 400;
              font-size: 20px;
            }
            @media (max-width: 767px) {
              text-align: left;
              font-weight: 400;
              font-size: 18px;
              max-width: 370px;
            }
          }
        }
        .image {
          width: 100%;
          max-width: 813px;
          height: auto;
          border-radius: 10px;
          box-shadow: -4px 4px 32px 0px #79919c80;
          @media (max-width: 1439px) {
            max-width: none;
          }
        }
      }
      .second-slide {
        flex-direction: row-reverse;
        @media (max-width: 1439px) {
          flex-direction: column;
          align-items: start;
        }
        @media (max-width: 767px) {
          align-items: end;
        }
        .description {
          padding-right: 0;
          padding-left: 2px;
          @media (max-width: 1439px) {
            align-items: start;
          }
          @media (max-width: 767px) {
            align-items: end;
          }
          .title,
          .text {
            text-align: right;
            @media (max-width: 1439px) {
              text-align: left;
            }
            @media (max-width: 767px) {
              text-align: right;
              max-width: 300px;
            }
          }
        }
      }
    }
  }
  .features {
    .content-wrapper {
      .slide {
        display: flex;
        position: relative;
        @media (max-width: 1439px) {
          flex-direction: column;
          justify-content: space-between;
          gap: 32px;
        }
        .description {
          display: flex;
          flex-direction: column;
          gap: 24px;
          padding-left: 24px;
          @media (max-width: 1439px) {
            padding: 0;
          }
          .title {
            font-family: Montserrat;
            font-weight: 600;
            font-style: SemiBold;
            font-size: 36px;
            line-height: 1;
            margin: 0;
            text-align: left;
            @media (max-width: 1439px) {
              font-weight: 700;
              font-size: 32px;
            }
            @media (max-width: 767px) {
              font-weight: 600;
              font-size: 24px;
            }
          }
          .text {
            font-family: Montserrat;
            font-weight: 400;
            font-style: Regular;
            font-size: 24px;
            line-height: 1;
            margin: 0;
            -webkit-line-clamp: unset;
            line-clamp: unset;
            @media (max-width: 1439px) {
              font-size: 20px;
            }
            @media (max-width: 767px) {
              font-size: 18px;
            }
          }
        }
        .image {
          width: 557px;
          min-width: 557px;
          height: auto;
          @media (max-width: 1439px) {
            margin: 0 auto;
            width: 586px;
            min-width: 586px;
          }
          @media (max-width: 767px) {
            width: calc(100% - 68px);
            min-width: calc(100% - 68px);
          }
        }
      }
    }
  }
  .notifications {
    .content-wrapper {
      .container {
        width: 100%;
        max-width: 1320px;
        height: 589px;
        min-height: 589px;
        background-color: #484e55;
        border-radius: 10px;
        padding: 93px 87px;
        position: relative;
        @media (max-width: 1439px) {
          height: 913px;
          padding: 280px 48px;
        }
        @media (max-width: 767px) {
          padding: 0 28px;
          padding-top: 210px;
          height: 770px;
        }
        .content {
          display: flex;
          flex-direction: column;
          gap: 50px;
          max-width: 590px;
          width: 100%;
          @media (max-width: 1439px) {
            max-width: 100%;
          }
          @media (max-width: 767px) {
            gap: 32px;
          }

          .description {
            display: flex;
            flex-direction: column;
            gap: 24px;
            color: #ffffff;

            .title {
              background-color: #484e55;
              font-family: Montserrat;
              font-weight: 600;
              font-size: 36px;
              line-height: 1;
              width: 480px;
              text-align: left;
              @media (max-width: 1439px) {
                font-size: 32px;
                width: 420px;
              }
              @media (max-width: 767px) {
                width: 100%;
                font-size: 24px;
              }
            }
            .text {
              font-family: Montserrat;
              font-weight: 500;
              font-style: Medium;
              font-size: 24px;
              line-height: 1;
              @media (max-width: 1439px) {
                font-size: 20px;
              }
              @media (max-width: 767px) {
                font-size: 18px;
              }
            }
          }
          .notifications-button {
            width: 384px;
            height: 79px;
            font-family: Montserrat;
            font-weight: 600;
            font-size: 24px;
            line-height: 100%;
            letter-spacing: 0%;
            align-self: flex-start;
            @media (max-width: 1439px) {
              align-self: flex-end;
            }
            @media (max-width: 767px) {
              align-self: center;
              width: 100%;
              font-size: 20px;
            }
          }
          .phone1 {
            position: absolute;
            top: 0;
            right: 283px;
            width: 389px;
            @media (max-width: 1439px) {
              height: 264px;
              width: auto;
              top: 0;
              left: 0;
            }
            @media (max-width: 767px) {
              height: 189px;
              top: 0;
              left: 0;
            }
          }
          .phone2 {
            position: absolute;
            bottom: 0;
            right: -23px;
            width: 389px;
            @media (max-width: 1439px) {
              height: 283px;
              width: auto;
              bottom: 0;
              right: 9px;
            }
            @media (max-width: 767px) {
              height: 202px;
              bottom: 0;
              right: 0;
            }
          }
        }
      }
    }
  }
  .reviews {
    .content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 80px;
      @media (max-width: 767px) {
        gap: 20px;
      }
    }
  }
  .callback {
    background-color: #484e55;
    .content-wrapper {
      background-color: #484e55;
      padding: 250px 0;
      display: flex;
      flex-direction: column;
      gap: 50px;
      @media (max-width: 1439px) {
        align-items: center;
        padding: 50px 0;
      }
      .title {
        color: #ffffff;
        background-color: #484e55;
        @media (max-width: 1439px) {
          width: 600px;
        }
        @media (max-width: 767px) {
          width: 100%;
          text-align: center;
        }
      }
    }
  }
  .faq {
    .content-wrapper {
      display: flex;
      flex-direction: column;
      gap: 80px;
    }
  }
  .tenders,
  .how-it-works,
  .features,
  .notifications,
  .reviews,
  .callback,
  .faq {
    .content-wrapper {
      max-width: 1440px;
      width: 100%;
      height: 100%;
      margin: 0 auto;
    }
  }
}
</style>
